import { connect } from 'react-redux';
import { changeStations } from '../../../store/stations/changeStations';
import { IGetVillageListResponseSchema } from '../../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import { StationsHeader } from './StationsHeader';
import { IStations } from '../../../store/stations';
import { changePopupStationDistance, filterPopupStations } from '../../../store/stations/actions';
import { commutePick } from '../../../utils/commutePick';

export interface IStationsHeaderProps {
  stationData: IGetVillageListResponseSchema['stationData'];
  stations: IStations;
}

export interface IStationsHeaderDispatchProps {
  onChangePopupStationDistance(value: number): void;
  onSelectSuggest(value: number): void;
  search(text: string, stationDistance?: number, trackNotFound?: boolean): void;
}

export type TStationsHeaderProps = IStationsHeaderProps & IStationsHeaderDispatchProps;

export function mapStateToProps(state: IApplicationState): IStationsHeaderProps {
  const {
    stations,
    villageList: { stationData },
  } = state;

  return {
    stationData: stationData ? commutePick(stationData, stations.currentStations) : undefined,
    stations,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IStationsHeaderDispatchProps {
  return {
    onChangePopupStationDistance: value => dispatch(changePopupStationDistance(value)),
    onSelectSuggest: value => dispatch(changeStations([value], true)),
    search: (text, stationDistance, trackNotFound) =>
      dispatch(filterPopupStations(text, stationDistance, trackNotFound)),
  };
}

export const StationsHeaderContainer = connect<IStationsHeaderProps, IStationsHeaderDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(StationsHeader);
